export const management = [
  "Select all",
  "Care Plans",
  "Expired DoLS",
  "Vaccinations Overdue",
  "Current Infections",
  "Open Incidents",
  "Interventions",
  "Severe & High Risks",
  "Staff Action",
  "DOM - missed calls",
  "Dom - late calls",
  "Medications",
  "Deleted & Amended Records",
];
